export async function morphFaces(img1, img2, landmarks1, landmarks2) {
  const createPointDefiner = async (img, landmarks) => {
    const imgWarperPoints = [];
    landmarks.positions.forEach((element) => {
      imgWarperPoints.push(
        /* eslint-disable no-undef */
        new ImgWarper.Point(Math.floor(element.x), Math.floor(element.y))
      );
    });

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = img.width;
    canvas.height = img.height;
    context.drawImage(img, 0, 0);
    const imgData = context.getImageData(0, 0, img.width, img.height);

    const pointDefiner = {
      imgData: imgData,
      oriPoints: imgWarperPoints,
    };

    return pointDefiner;
  };

  const pointDefiner1 = await createPointDefiner(img1, landmarks1);
  const pointDefiner2 = await createPointDefiner(img2, landmarks2);

  const imageCreator = new ImgWarper.ImageCreator(pointDefiner1, pointDefiner2);

  return imageCreator.generate(0.5, 0.5);
}
